import { faClose, FaIcon, faIdBadge } from '@/lib/fa'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GroupsModalHeader = ({
  close,
  driverName,
}: {
  close: () => void
  driverName: string
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-4">
      <div className="tw-ml-4 tw-flex tw-flex-col tw-items-start tw-gap-2">
        <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
          {t('driverModule.add-driver-to-group')}
        </p>
        {driverName && (
          <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm">
            <p className="tw-m-0">{t('driverModule.add-driver')}</p>
            <div className="tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-base-300 tw-px-1">
              <FaIcon icon={faIdBadge} className="tw-cursor-pointer" />
              <span>{driverName}</span>
            </div>
            <p className="tw-m-0">{t('driverModule.to-groups')}</p>
          </div>
        )}
      </div>
      <FaIcon
        icon={faClose}
        className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
        onClick={() => close()}
      />
    </div>
  )
}

export default GroupsModalHeader
